import React from 'react';
import {Link} from "react-router-dom";
import {addSavedRoute, removeSavedRoute} from "../../actions";
import {connect} from "react-redux";
import {withTranslation} from 'react-i18next';
import {compose} from 'redux';
import {useAuth} from "../../context/auth-context";
import {useUser} from "../../hooks/useUser";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import AlertUnlockComponent from "../AlertUnlockComponent";
import Constants from "../../config/constants";
import {getErrorsFromResponse, getTypeFromListItem} from "../../utils/helpers";
import FabRoute from "../FabRoute";
import WarningComponent from "../WarningComponent";
import TooltipComponent from "../TooltipComponent";
import {Alert, Box, Grid, Typography} from "@mui/material";
import RegionRoute from "../RegionRoute";
import {MuiButton} from "../MuiButton";
import OpenCloseWysiwigContent from "../OpenCloseWysiwigContent";
import useSEO from "../../hooks/useSEO";
import {getUrl, PWAUrls, PWAUrlsParams, replaceUrlParams} from "../../config/urls";
import {format} from "date-fns";
import GlobalFlashMessages from "../User/FlashMessages/FlashMessages";
import VoieSwitchComponent from "./VoieSwitchComponent";

const VoieComponent = ({t, i18n, voie, saveRoute, unsaveRoute, error, status, unlock, isOnline}) => {
    const auth = useAuth();
    const {data, status: statusStoredRoutes} = useUser(auth.user?.email, i18n.language);
    const storedRoutes = Array.isArray(data?.user?.customerRoutes) ? data.user.customerRoutes : [];
    const hasStoreRoute = Array.isArray(storedRoutes) ? storedRoutes.find((el) => el?.type === Constants.TypeTopo.GRANDEVOIE && el?.route.id === voie.id) : false;
    const isSaved = typeof hasStoreRoute !== 'undefined' && hasStoreRoute ;

    let lastUpdateUi = null;
    if (typeof voie.lastUpdateUi !== 'undefined' && voie.lastUpdateUi) {
        lastUpdateUi =  format(new Date(voie.lastUpdateUi.slice(0, 10)), 'dd/MM/yyyy');
    }

    const tickingType = Constants.allTickingTypeOptions.find((o) => o.value == voie.ticking?.tickingType);
    const presentationUrl = voie?.presentation?.enabled ? getUrl(PWAUrls.PRESENTATION, {lng: i18n.language, slug: voie?.presentation?.slug }): false;

    const seoTitleParams = {label: voie.label, region: voie.region.label, face: voie.faceLabel};
    const seoDescriptionParams = {...seoTitleParams, maxGrade: voie.maxGradeLabel, difficulty: voie.difficulty, length: voie.length + 'm'}
    // if (secteur.barChart.length === 1) {
    //     seoDescriptionParams.grades = t('seo.grade', {grade: secteur.barChart[0].grade});
    // } else {
    //     seoDescriptionParams.grades = t('seo.grades', {minGrade: secteur.barChart[0].grade, maxGrade: secteur.barChart[secteur.barChart.length -1].grade});
    // }

    const canonical = getUrl(PWAUrls.MULTIPITCH_ROUTE, {lng: i18n.language, routeType: getTypeFromListItem(voie,  i18n.language), slugRegion: voie.region.slug, slug: voie.slug});
    useSEO({
        title: t("seo.title.multi_pitch_route", seoTitleParams),
        description: t("seo.description.multi_pitch_route", seoDescriptionParams)},
        canonical
    );

    return (
        <div className="row voieContent">
            <div className="col-12">
                <Box display="flex" alignItems="center">
                    <Box flexGrow={1} className="mb-3">
                        <h2 className="mt-3 mb-0">
                            {voie.label + " "}
                            {lastUpdateUi && <TooltipComponent title={t("SecteurListComponent.popover.last_update", {lastUpdateUi: lastUpdateUi})} color="tertiary">
                                <span className="white"><FontAwesomeIcon icon={['fa', 'fire']} size="sm" /></span>
                            </TooltipComponent>}
                            {tickingType && <FontAwesomeIcon icon={tickingType.icon} className={tickingType.color} title={t(tickingType.label)} style={{marginLeft: '8px'}} />}
<br/>
                            <small>{voie.faceLabel} {parseInt(voie.faceHeight) > 0 && <React.Fragment>{"("+ voie.faceHeight + "m)"}</React.Fragment>}</small>
                            {/*Keep ?, it route is stored, routesFromFace could be empty*/}
                            {voie?.routesFromFace?.length > 1 && <VoieSwitchComponent route={voie}/>}
                        </h2>
                    </Box>
                    <Box>
                        {voie.presentation && <MuiButton component={Link}
                                                         to={presentationUrl}
                                                         variant="contained" color="primary"
                        >
                            <FontAwesomeIcon icon={['fas', 'info-circle']} size="lg" className="white"/>
                            &nbsp;{t('App.components.PresentationComponent.button')}
                        </MuiButton>}
                    </Box>
                </Box>

                {voie?.region?.breadcrumb && <RegionRoute label={voie?.region?.breadcrumb}
                                                          className={Constants.MULTIPITCH}/>}

                {voie.authorInfo && <Typography variant="body1" gutterBottom><b dangerouslySetInnerHTML={{__html:voie.authorInfo}}/></Typography>}

                <Grid item xs={12}>
                    {/*<Box sx={{ p: 1, }}>*/}
                        {voie.warning && <div className="float-right mb-2">
                            <WarningComponent title={voie.warning} />
                        </div>}

                        <dl className="dl-inline m-0 mb-3" style={{paddingTop: voie.warning ? '34px' : 'inherit'}}>
                            {voie.infos && <React.Fragment>
                                <dd className="wysiwyg dd-no-dt" dangerouslySetInnerHTML={{__html:voie.infos}}/>
                            </React.Fragment>}
                            {voie.rockTypeLabel && <React.Fragment>
                                <dt>{t('SecteurListComponent.properties.label.rock_type')} </dt>
                                <dd>{voie.rockTypeLabel}</dd>
                            </React.Fragment>}
                            {voie.orientation && <React.Fragment>
                                <dt>{t('SecteurComponent.properties.orientation')} </dt>
                                <dd>{voie.orientation}</dd>
                            </React.Fragment>}
                            {voie.climbingStyle && <React.Fragment>
                                <dt>{t('SecteurComponent.properties.climbing_style')} </dt>
                                <dd>{voie.climbingStyle}</dd>
                            </React.Fragment>}
                            {voie.times && <React.Fragment>
                                <dt>{t('SecteurComponent.properties.times')} </dt>
                                <dd dangerouslySetInnerHTML={{__html:voie.times}}/>
                            </React.Fragment>}
                            {voie.equipmentType && <React.Fragment>
                                <dt>{t('SecteurComponent.properties.equipmentType')} </dt>
                                <dd>{voie.equipmentType}</dd>
                            </React.Fragment>}
                            {(voie.firstAscentShort || voie.firstAscent) && <React.Fragment>
                                <dt>{t('SecteurComponent.properties.firstAscent')}</dt>
                                <dd>
                                    <OpenCloseWysiwigContent description={voie.firstAscent}
                                                             descriptionShort={voie.firstAscentShort}
                                                             openCta={'\u00A0 +'}
                                                             closeCta={'\u00A0 -'}
                                    />
                                </dd>
                            </React.Fragment>}

                            {voie.requiredMaterial && <React.Fragment>
                                <dt>{t('SecteurComponent.properties.requiredMaterial')} </dt>
                                <dd>{voie.requiredMaterial}</dd>
                            </React.Fragment>}
                            {voie.descentType && <React.Fragment>
                                <dt>{t('SecteurComponent.properties.descentType')} </dt>
                                <dd>{voie.descentType}</dd>
                            </React.Fragment>}
                        </dl>
                    {/*</Box>*/}
                </Grid>
            </div>
            <Box sx={{ p: 2, }}>
                <OpenCloseWysiwigContent
                    title={t('SecteurComponent.properties.description')}
                    description={voie.description}
                    descriptionShort={voie.descriptionShort} />
            </Box>

            {!unlock && <Grid item xs={12}>
                <Box sx={{ p: 2, }}>
                <AlertUnlockComponent guidebooks={voie.guidebookInfos}
                                      routeType={Constants.TypeTopo.GRANDEVOIE}
                                      secteur={voie.product}
                />
                </Box>
            </Grid>}

            <div className="col-12 pt-3">
                {unlock && <GlobalFlashMessages regionIds={voie?.regionDescendantIds}/>}
                <div className="row justify-content-lg-center align-items-center mb-3">
                    <div className="col-12 col-md-6 mb-lg-2 mt-2 mt-lg-0">
                        {unlock && <>
                            {error && <Alert
                                severity='error'
                                style={{marginTop: "15px", marginBottom: "15px"}}>
                                {getErrorsFromResponse(error.response).map((e, i) => {
                                    return (<span key={i}>{e}<br/></span>);
                                })}
                            </Alert>}
                            {isSaved && <MuiButton
                                onClick={unsaveRoute}
                                className="m-0"
                                disabled={status === "pending" || !isOnline}
                                variant="contained" color="secondary" fullWidth>
                                {status === "pending" && <FontAwesomeIcon icon={["fas", "spinner"]} spin className="mr-2" />}
                                {status !== "pending" && <FontAwesomeIcon icon={["fas", "save"]} className="mr-2"/>}
                                {t('SecteurComponent.button.saved')}
                            </MuiButton>}
                            {!isSaved && <MuiButton
                                onClick={saveRoute}
                                className="m-0"
                                disabled={status === "pending" || statusStoredRoutes !== "success" || storedRoutes.length >= import.meta.env.VITE_MAX_STORAGE || !isOnline}
                                variant="contained" color="primary" fullWidth>
                                {t('SecteurComponent.button.save')}
                            </MuiButton>}
                        </>}

                        <div className="row justify-content-center mb-0">
                            {voie.hasGmapsLink && <div className={"text-center " + (voie.hasApproachScreen ? 'col-6' : 'col-12')}>
                                <MuiButton
                                   target="_blank"
                                   href={voie.gmapsLink}
                                   className="mt-1"
                                   disabled={!unlock}
                                   variant="contained" color="primary" fullWidth>
                                    {t('SecteurComponent.button.gmaps_link')}
                                </MuiButton>
                            </div>}
                            {voie.hasApproachScreen &&
                            <div className={"text-center " + (voie.hasGmapsLink ? 'col-6' : 'col-12')}>
                                <MuiButton to={window.location.pathname + "/" + PWAUrlsParams.approach[i18n.language]}
                                           component={Link}
                                           className="mt-1"
                                           disabled={!unlock}
                                           variant="contained" color="primary" fullWidth>{t('SecteurComponent.button.approach')}</MuiButton>
                            </div>
                            }
                        </div>
                    </div>
                    <div className="col-12 col-md-6 mb-lg-2 mt-1 mt-lg-0">
                        {voie.hasDetailsScreen && <MuiButton to={window.location.pathname + "/" + PWAUrlsParams.details[i18n.language]}
                                                             component={Link}
                                                             className="mt-0 mb-1"
                                                             disabled={!unlock }
                                                             variant="contained" color="primary" fullWidth>{t('SecteurComponent.button.route')}</MuiButton>}
                    </div>
                    {unlock && <div className="col-6 mb-lg-2 mt-1 mt-lg-0">
                        <MuiButton onClick={() => window.open("mailto:"+import.meta.env.VITE_CONTACT_MAIL+"?subject=" + encodeURIComponent(t('SecteurComponent.report.subject') + voie.label),"_self")} color="quaternary" className="m-0" variant="contained" fullWidth>
                            {t('SecteurComponent.button.report')}
                        </MuiButton>
                    </div>}
                    {unlock && <div className="col-6 mb-lg-2 mt-1 mt-lg-0">
                        {voie.ticking?.id &&  <MuiButton to={replaceUrlParams(window.location.pathname + "/{ticking}/{crudView}/" + voie.ticking.id, i18n.language)}
                                                         component={Link}
                                                      className="mt-0"
                                                      variant="contained" color="primary" fullWidth>{t('SecteurComponent.button.ticking')}</MuiButton>}
                        {!voie.ticking?.id && voie.tickingId === null && <MuiButton to={replaceUrlParams(window.location.pathname + "/{ticking}/{crudCreate}", i18n.language)}
                                                                                    component={Link}
                                                                                    className="mt-0"
                                                                                    variant="contained" color="primary" fullWidth>
                            <FontAwesomeIcon icon={['fas', 'plus']} style={{marginRight: '4px'}} />
                            {t('SecteurComponent.button.ticking')}
                        </MuiButton>}
                    </div>}
                    {unlock && <div className="col-12 col-lg-auto text-center text-lg-left mt-2 mt-lg-0">
                        <p className="m-0 text-tertiary small-help">{t('SecteurComponent.button.report_help')}</p>
                    </div>}
                </div>
            </div>
            <FabRoute
                unlock={unlock}
                route={voie}
                product={voie?.product}
                type={Constants.TypeTopo.GRANDEVOIE}
            />
        </div>
    );
}


const mapDispatchToProps = dispatch => {
    return {
        addSavedRoute: (route) => {
            dispatch(addSavedRoute(route))
        },
        removeSavedRoute: (route) => {
            dispatch(removeSavedRoute(route))
        },
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        savedRoutes: state.navbar.savedRoute,
        isOnline: state.common.isOnline,
    }
}

export default
    compose(
        withTranslation(),
        connect(
            mapStateToProps,
            mapDispatchToProps
        ))(VoieComponent);